
import Vue, { PropType } from 'vue';

export default Vue.extend({
    props: {
        visible: {
            type: Boolean as PropType<boolean>,
            default: false
        }
    }
});
